import React from 'react'
import { CategoryData, SizeData } from '../../../features/setup/setupResponse';
import { setUpCategory } from '../../../data/admin-data';
import Loading from '../../ui/Loading';
import ErrorMessage from '../../ui/ErrorMessage';
import { useDispatch } from 'react-redux';
import { setPopulateCategory, setPopulateSizes, setSetup, setSetupTypeId } from '../../../features/setup/setupSlice';

interface SetupSizesTBodyProps {
    data: SizeData[];
    isLoading: boolean
    isError: boolean
    errorMessage: string;
    isEmpty: boolean
}

export default function SetupSizesTBody({ data, isLoading, isEmpty, errorMessage, isError }: SetupSizesTBodyProps) {
    
    const dispatch = useDispatch()

    return (
        <tbody className='w-full'>
            {isLoading ? (
                <tr>
                    <td colSpan={setUpCategory.length}  className='h-auto text-center'> 
                        <div className="flex space-x-1 justify-center items-center w-full h-full">
                            <Loading message="Loading product..." />
                        </div>
                    </td>
                </tr>
            ) : isError ? (
                <tr>
                    <td colSpan={setUpCategory.length}  className="py-8">
                        <div className="flex items-center justify-center w-full text-xs">
                            <ErrorMessage message={errorMessage} textStyle={``}/>
                        </div>
                    </td>
                </tr>
            ) : isEmpty ? (
                <tr>
                    <td colSpan={setUpCategory.length}  className="py-8">
                        <div className="flex items-center justify-center w-full text-xs">
                            <p className='text-gray-500 text-xs'>No result found.</p>
                        </div>
                    </td>
                </tr>
            ) : (
                data.map((data, index) => {
                    const isActive = data.isActive ? 'Active' : 'Inactive'
                    return (
                        <tr 
                            key={data.sizeId} 
                            className={`hover:bg-gray-100 text-xs cursor-pointer ${index % 2 === 0 ? "bg-white" : "bg-gray-100"}`}
                        >
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-medium">
                                        {data.size}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <span
                                    className={`inline-flex rounded px-2 py-0.5 text-xs font-medium ${
                                        data.isActive
                                            ? "bg-green-100 text-green-700"
                                            : "bg-red-100 text-red-700"
                                    }`}
                                >
                                    {isActive}
                                </span>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    <button
                                        onClick={() => {
                                            dispatch(setPopulateSizes({ size: data.size, isActive: data.isActive }))
                                            dispatch(setSetupTypeId(data.sizeId))
                                            dispatch(setSetup({ type: 'show', value: 'setUpSize'}))
                                            dispatch(setSetup({ type: 'update', value: 'setUpSizeUpdate'}))
                                        }}
                                        className="text-cbColor text-xs px-4 py-1.5 rounded transition"
                                    >
                                        Edit
                                    </button>
                                </div>
                            </th>
                        </tr>
                    )
                })
            )}
        </tbody>
    )
}
